import { api } from '../../../AxiosConfig';

interface UserProfile {
    displayName: string;
    photoURL: string;
    phoneNumber?: string;
}

class UserService {
    create(data: {
        email: string;
        name: string;
        estabId?: string;
        phone?: string;
        estabName?: string;
        atendentes?: string[];
        selfSchedulingBlocked?: boolean;
        selfSchedulingBlockMode?: 'ALL' | 'WEEK_DAYS';
        selfSchedulingBlockedWeekDays?: number[];
    }) {
        return api.post('users/clients/create', data);
    }

    createClient(data: { name: string; }) {
        return api.post('users/atendentes/createClient', data);
    }

    switchEstab(estabId: string) {
        return api.post('users/switch-estab', { estabId });
    }

    getSettings() {
        return api.get('users/settings');
    }

    updateSettings(update: any) {
        return api.post('users/settings/update', { update });
    }

    activeAccount(uid: string, code: string, password: string) {
        return api.post('users/activeAccount', { uid, code, password });
    }

    updateProfile(update: UserProfile) {
        return api.post('users/updateProfile', update);
    }

    removePhoneNumber() {
        return api.post('users/removePhoneNumber');
    }

    requestChangeEmail(email: string) {
        return api.post('users/requestChangeEmail', { email });
    }

    saveTokenPushNotification(token: string, deviceType: 'web' | 'android' | 'ios' = 'web') {
        return api.post('users/saveTokenPushNotification', { token, deviceType });
    }

    requestRecoverPassword(email: string) {
        return api.post('users/requestRecoverPassword', { email });
    }

    recoverPassword({
                        uid, code, password,
                    }: {
        uid: string; code: string; password: string;
    }) {
        return api.post('users/recoverPassword', {
            uid, code, password,
        });
    }

    changeEmail(code: string) {
        return api.post('users/changeEmail', { code });
    }

    requestChangePhoneNumber(phoneNumber: string) {
        return api.post('users/requestChangePhoneNumber', { phoneNumber });
    }

    changePhoneNumber(code: string, uid: string) {
        return api.post('users/changePhoneNumber', { code, uid });
    }

    addUserClientEstab(estabId: string) {
        return api.post('users/addUserClientEstab', { estabId });
    }

    removeUserClientEstab(estabId: string) {
        return api.post('users/removeUserClientEstab', { estabId });
    }

    getEstabsUser() {
        return api.get('/users/getEstabsUser');
    }

    getClients(search?: string, grupoId?: string, atendenteId?: string, includeUnassigned?: boolean) {
        const params: any = {};

        if (search?.trim()) {
            params.search = search.trim();
        }

        if (grupoId?.trim()) {
            params.grupoId = grupoId.trim();
        }

        if (atendenteId?.trim()) {
            params.atendenteId = atendenteId.trim();
        }

        if (includeUnassigned !== undefined) {
            params.includeUnassigned = includeUnassigned;
        }

        return api.get('/users/clients', { params });
    }

    getClientDetails(userId: string) {
        return api.get(`/users/clients/details/${userId}`);
    }

    removeClient(uid: string) {
        return api.post('/users/clients/remove', { uid });
    }

    getAgendamentoByClientId(clientId: string) {
        return api.get('/users/clients/agendamentos', { params: { clientId } });
    }

    updateClientGroups(userId: string, gruposIds?: string[], atendentes?: string[]) {
        return api.post('/users/clients/update-groups', { userId, gruposIds, atendentes });
    }

    updateClient(data: {
        userId: string;
        displayName: string;
        email?: string;
        phoneNumber?: string;
        photoURL?: string;
        atendentes?: string[];
        selfSchedulingBlocked?: boolean;
        selfSchedulingBlockMode?: 'ALL' | 'WEEK_DAYS';
        selfSchedulingBlockedWeekDays?: number[];
    }) {
        return api.post('/users/clients/update', data);
    }
}

export { UserService };
